import React, { JSX } from 'react';
import Keys from '../../../_Translations/generated/service-list.en.t.json.keys';
import fallback from '../../../_Translations/generated/service-list.en.t.json';
import useTranslation from '../../Hooks/useTranslation';
import { FilterProperties } from './externals';
import { Button } from 'reactstrap';

function FilterDiscard({ filterProps }: { filterProps?: FilterProperties }): JSX.Element {
  const { t } = useTranslation('service-list', fallback, Keys);

  return (
    <>
      {filterProps && (
        <div className="iso__filter__discardContainer">
          <Button
            color="link"
            onClick={filterProps?.onFiltersDiscard}
            className="border-0 p-0 font-weight-normal iso__filter__resetButton"
          >
            {t(Keys.discardFilters)}
          </Button>
        </div>
      )}
    </>
  );
}

export default FilterDiscard;
